<div class="app-bg" aria-hidden="true">
  <span class="blob b1"></span>
  <span class="blob b2"></span>
</div>
<app-header></app-header>
<main style="min-height: 80vh; padding-top: 64px;">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
